export function checkTextInArray(array, text) {
  return array.includes(text);
}

export function isArray(arr) {
  return Array.isArray(arr);
}

export function generateNumbers(totalNumber) {
  let array = [];
  for (let i = 1; i <= totalNumber; i++) {
    array.push(i);
  }
  return array;
}

export function findItemByFiled(arr, field, value) {
  return arr?.find((item) => item[field] === value);
}

export function arrayTextPrint(arr) {
  return arr?.filter((item) => item)?.join(", ") || "-";
}

// handle array map have length
export function arrayMap(data, executor) {
  if (Array.isArray(data) && data.length) {
    return data.map(executor);
  } else {
    return "";
  }
}

// chunk array object by size
export function chunkArray(array, chunkSize) {
  if (!Array.isArray(array) || chunkSize <= 0) {
    return [];
  }

  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    result.push(chunk);
  }

  return result;
}
